/*
 * Shared Razorpay checkout for the NOC fee.
 *
 * The student dashboard, the center dashboard and the public website all pay
 * for a NOC the same way: the server has already created the order and handed
 * back { order_id, amount, key_id }, so here we only open Checkout and report
 * back the payment id. Keeping this in one place means the three screens cannot
 * drift apart.
 */

export const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

/**
 * Open Checkout for an order the server created.
 *
 * @param {object} data  the `data` block from a NOC apply response
 *                       ({ order_id, amount, currency, key_id, fee, name, purpose })
 * @returns {Promise<{payment_id?:string, error?:string, dismissed?:boolean}>}
 */
export const openNocCheckout = (data) =>
  new Promise(async (resolve) => {
    const ok = await loadRazorpay();
    if (!ok) {
      resolve({ error: "Razorpay could not load. Please check your internet connection." });
      return;
    }

    const options = {
      key: data.key_id,
      amount: data.amount, // already in paise from the server
      currency: data.currency || "INR",
      order_id: data.order_id,
      name: "NSVEC",
      description: `NOC Fee${data.purpose ? " | " + data.purpose : ""}`,
      handler: (resp) => resolve({ payment_id: resp.razorpay_payment_id }),
      prefill: { name: data.name || "" },
      theme: { color: "#1f3c88" },
      modal: { ondismiss: () => resolve({ dismissed: true }) },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", () =>
      resolve({ error: "The payment failed. No NOC was issued." })
    );
    rzp.open();
  });

/* The digital note shown on the apply form and printed on the certificate. */
export const NOC_DIGITAL_NOTE =
  "This certificate is online generated and digitally issued by NSVEC. No physical signature or stamp is required for this digitally generated certificate.";
